import { IntakeSectionHeader, StyledGridRow } from "@/common/styles";
import { staticFields } from "@/util/common_variable";
import { Formik } from "formik";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { FormContainer } from "./styles";
import DynamicForm from "@/common/DynamicForm";
import { Form } from "antd";
import dayjs from "dayjs";
import {
  findAgefromDOB,
  getVisibleFields,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import { useDispatch, useSelector } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";

export const PERSON = {
  INMATE: "INMATE",
  VISITOR: "VISITOR",
  VISITOR_LOG: "VISITOR_LOG",
  BOOKINGS: "BOOKINGS",
  LOW: "LOW",
  STAFF: "STAFF",
};

const Personal = forwardRef(
  ({
    header,
    person = PERSON.INMATE,
    personalFormRef,
    formData = {},
    onUpdateForm = () => {},
    startingPoint = "",
  }) => {
    const dispatch = useDispatch();
    const { bookings, bookingsFieldsEnabled } = useSelector(
      (state) => state?.bookings
    );
    const [form] = Form.useForm();
    const [personalInfoForm, setPersonalInfoForm] = useState(null);
    const fullSearch = useSelector(state => state.fullSearch);
    useEffect(() => {
      const bio = bookings?.bio?.[0];
      // const visitor = formData || {};
      // if (person === PERSON.VISITOR && isNonEmptyVariable(visitor)) {
      //   setPersonalInfoForm(() => ({
      //     ...visitor,
      //     dob: dayjs(),
      //   }));
      // } else
      if (isNonEmptyVariable(bio)) {
        setPersonalInfoForm(() => ({
          ...bio,
          complexion: bio?.complexion?.trim() ?? null,
          glasses: bio?.glasses?.trim() ?? null,
          dob: isNonEmptyVariable(bio?.dob) ? dayjs(bio?.dob) : null,
          dlExpiration: isNonEmptyVariable(bio?.dlExpiration)
            ? dayjs(bio?.dlExpiration)
            : null,
          ageAtEntry: isNonEmptyVariable(bio?.dob)
            ? findAgefromDOB(dayjs(bio?.dob)?.format("MM/DD/YYYY"))
            : null,
        }));
      } else {
        setPersonalInfoForm(null);
      }
    }, [bookings]);

    useEffect(() => {
      if (personalInfoForm === null) {
        form.resetFields();
      } else {
        form.setFieldsValue(personalInfoForm);
      }
    }, [personalInfoForm]);

    // Expose form methods to parent
    useImperativeHandle(personalFormRef, () => ({
      submitForm: () => form.submit(),
      resetForm: () => form.resetFields(),
      getFormValues: () => form.getFieldsValue(),
      getFieldsError: () => form.getFieldsError(),
      isFieldsValidating: () => form.isFieldsValidating(),
      validateFields: (options) => form.validateFields(options),
      form: form,
    }));

    const updateForm = (data) => {
      if (person === PERSON.VISITOR) {
        onUpdateForm(data);
      } else {
        dispatch(
          setBookings({
            bio: [
              {
                ...bookings?.bio?.[0],
                ...data,
              },
            ],
            arrestReports: [
              {
                ...bookings?.arrestReports?.[0],
                inmateTypeId: !fullSearch ? (data?.ageAtEntry < 18 ? 154540005 : 154540001) : null,
              },
            ],
          })
        );
      }
    };
    console.log(personalInfoForm)
    return (
      <FormContainer>
        {header && (
          <IntakeSectionHeader>
            <span>{header}</span>
          </IntakeSectionHeader>
        )}

        <Form
          form={form}
          disabled={!bookingsFieldsEnabled}
          initialValues={personalInfoForm}
          onBlur={(e) => {
            const ignoredClasses = [
              "ant-picker-header-super-next-btn",
              "ant-picker-date-panel",
              "ant-picker-header-super-prev-btn",
            ];
            const ignoredIds = ["dob", "dlExpiration"];
            const isIgnored =
              ignoredClasses.includes(e.target.className) ||
              ignoredIds.includes(e.target.id);

            if (isIgnored) return;

            const values = form.getFieldsValue();
            values.dob = values?.dob
              ? dayjs(values?.dob)?.format("MM/DD/YYYY")
              : null;
            values.dlExpiration = values?.dlExpiration
              ? dayjs(values?.dlExpiration)?.format("MM/DD/YYYY")
              : null;
            updateForm(values);
          }}
          onFieldsChange={(sf) => {
            if (
              sf?.[0]?.name?.[0] === "dob" ||
              sf?.[0]?.name?.[0] === "dlExpiration"
            ) {
              const values = form.getFieldsValue();

              const data = {
                dob: values?.dob
                  ? dayjs(values?.dob)?.format("MM/DD/YYYY")
                  : null,
                dlExpiration: values?.dlExpiration
                  ? dayjs(values?.dlExpiration)?.format("MM/DD/YYYY")
                  : null,
              };

              const age = findAgefromDOB(data?.dob);

              data.ageAtEntry = age;
              updateForm(data);
            }
          }}
        >
          <StyledGridRow gutter={[16]}>
            {staticFields?.personalInfo[person]?.map((sf, index) => {

              let view = hasCheckSecurity(
                "Functionality",
                "field",
                "VIEW",
                "",
                "",
                "Bio",
                sf.columnName,
                startingPoint
              );
              let edit = hasCheckSecurity(
                "Functionality",
                "field",
                "MODIFY",
                "",
                "",
                "Bio",
                sf.columnName,
                startingPoint
              );
              return (
                <DynamicForm
                  formAttributes={sf}
                  i={index}
                  form={form}
                  bookingsFieldsEnabled={bookingsFieldsEnabled}
                  view={view}
                  edit={edit}
                  person={person}
                  fullSearch={fullSearch}
                />
              );
            })}
          </StyledGridRow>
        </Form>
      </FormContainer>
    );
  }
);

export default Personal;
